module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\nuniform sampler2D tex_Color;\r\n\r\nin vec4 fs_Pos;        \r\nin vec2 fs_UV;\r\n\r\nout vec4 out_Col;\r\nuniform float u_highlight;\r\nuniform float u_alpha;\r\nuniform float u_Time;\r\n\r\nvoid main() {\r\n\tvec4 cs = pow(texture(tex_Color, fs_UV), vec4(2.2));\r\n\t// base color\r\n\tvec3 col = pow(vec3(pow(cs.r, 2.2)), vec3(2.4, 0.75, 0.62));\r\n\tcol += vec3(2.3, 2.3, 2.0) * u_highlight * vec3(cs.g) * (1.25 + 0.75 * sin(u_Time * 6.28));\r\n\tout_Col = vec4(2.0 * col * u_alpha, cs.a * u_alpha);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/alphaUnlit-frag.glsl
// module id = 23
// module chunks = 0